import { UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { action, observable } from 'mobx';

import { MediaAsset } from '../../../../entities/MediaAsset';
import { RailStoreV2 } from '../rail-store-v2';

const DEFAULT_HEIGHT_RAIL_CARD = 159;
const DEFAULT_WIDTH_RAIL_CARD = 272;

export class AppsRailStoreV2 extends RailStoreV2 {
  subtype: UIDAPresentationTypeEnum.apps = UIDAPresentationTypeEnum.apps;
  @observable protected innerItems: MediaAsset[] = [];
  protected _removeInvisible = false;

  heightRailCard = DEFAULT_HEIGHT_RAIL_CARD;
  widthRailCard = DEFAULT_WIDTH_RAIL_CARD;

  @action setItems(items: MediaAsset[]) {
    // image resize
    this.innerItems = items;
    this.totalItemsCount = items.length;
  }

  protected async getData(
    pageIndex: number,
    items: MediaAsset[],
  ): Promise<{ items: MediaAsset[]; totalCount: number; newItems: MediaAsset[] }> {
    return { items: this.items as MediaAsset[], totalCount: this.totalItemsCount, newItems: items };
  }

  protected async getAdditionData(): Promise<void> {
    return undefined;
  }

  protected async restoreAdditionData(pageIndex: number, items: MediaAsset[]): Promise<void> {
    return undefined;
  }
}
